import { render, staticRenderFns } from "./OnboardingPhotoRules.vue?vue&type=template&id=0afa219e&"
import script from "./OnboardingPhotoRules.vue?vue&type=script&lang=js&"
export * from "./OnboardingPhotoRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports